import React from "react";
import ActivityPhotoForm, { PHOTO_SUBMISSION_ACTIVITY_ID } from "./ActivityPhotoForm.js";

const ActivityPhotoSubmissionForm = (props) => (
  <ActivityPhotoForm {...props} appId={PHOTO_SUBMISSION_ACTIVITY_ID} />
);

export default ActivityPhotoSubmissionForm;
